import React from "react";
import { nutritionalRatingOptions } from "../../Options/clinicalEvaluationOptions";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";

const NutritionalScreeningRating = ({ form, risk = false }) => {
  return (
    <>
      <DeselectableRadioGroup
        label={risk ? "Nutritional Status" : "Nutritional Screening"}
        name={risk ? "nutritional_status" : "nutritional_screening"}
        options={nutritionalRatingOptions}
        form={form}
      />
    </>
  );
};

export default NutritionalScreeningRating;
